import { ParticipantKind, type Participant } from 'livekit-client';

/**
 * True when the participant is a LiveKit AGENT (e.g., our Sarvam-backed
 * transcription bot). Identity-string matching is forbidden — backend
 * may rename agents at dispatch time. `kind` is the LiveKit-blessed signal.
 */
export function isAgentParticipant(participant: Pick<Participant, 'kind'>): boolean {
  return participant.kind === ParticipantKind.AGENT;
}
